import request from '@/utils/request'

export function getUser() {
  return request({
    url: '/user',
    method: 'get'
  })
}

export function getUserDetails() {
  return request({
    url: '/userCenter/getDetails',
    method: 'get'
  })
}

export function add(data) {
  return request({
    url: '/user',
    method: 'post',
    data
  })
}

export function del(id) {
  return request({
    url: '/user/' + id,
    method: 'delete'
  })
}

export function edit(data) {
    return request({
      url: '/user',
      method: 'put',
      data
    })
}

/**
 * 重置密码
 * @param data
 */
export function reset(data) {
    return request({
      url: '/user/reset',
      method: 'put',
      data
    })
}

/**
 * 修改密码
 */
export function updatePwd(params) {
  return request({
    url: '/user/updatePwd',
    method: 'put',
    params
  })
}

/**
 * 用户中心重置密码
 * @param data
 */
export function resetUserPwd(data) {
  return request({
    url: '/userCenter/updatePwd',
    method: 'post',
    data
  })
}

/**
 * 模拟用户登录
 * @param data
 */
export function simulationLogin(id) {
  return request({
    url: '/userCenter/simulationLogin/' + id,
    method: 'get'
  })
}